var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.picture!='-')?_c('img',{attrs:{"src":_vm.sanitizeLink(_vm.data.picture),"width":"100","height":"100"}}):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }